import type { FC } from 'react';
import type { HexColor } from 'src/types/colors';
import { colors } from 'styles/colors';

type Props = {
  color?: HexColor;
};

export const ChevronLeftWithBorderIcon: FC<Props> = ({ color = colors.gray500 }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white" />
    <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke={color} />
    <path d="M22 25.0002L17 20.0002" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M22 15L17 20" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
